import { bearerAuthOptions } from "./util";
import { apiUrl } from "../config";
import axios from "axios";

export function submitSurvey(classID, survey, language, sessionId) {
	const options = { ...bearerAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.post(
		`${apiUrl}/survey`,
		{ classID, ...survey, liveClassSessionId: sessionId },
		options,
	);
}



// WEBPACK FOOTER //
// ./src/api/survey.js